jQuery(document).ready(function($){

    $('[data-modal-open]').click(function() {
        let $el = $('#' + $(this).data('modal-open'));

        if ($el.length) {
            let product_name = $(this).data('modal-product');
            let product_photo = $(this).data('modal-photo');

            let modal_title = document.querySelector('[data-modal-product-title]');

            if (modal_title !== null) {
                modal_title.textContent = product_name;
            }

            let product_field = document.querySelector('input[name="your-product"]');

            if (product_field !== null) {
                product_field.setAttribute('value', product_name);
            }

            let modal_photo = document.querySelector('[data-modal-product-photo]');

            if (product_photo && modal_photo !== null) {
                modal_photo.innerHTML = `<img src="${product_photo}" alt="" />`;
            }

            document.querySelector('.modal-contact__product').classList.add('is-active');

            $el[0].showModal();
        }
    });

    $('dialog').click(function(event) {
        if (event.target !== this) {
            return;
        }

        this.close();
    });

});
